
<button class="mt-5 ms-5" (click)="mostrarInfo()">Mostrar Informações do Navegador</button>

